import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/img/logo.svg';
import menuIcon from '../assets/img/menu.svg';
import closeIcon from '../assets/img/close.svg';
import downIcon from '../assets/img/down.svg';
import { Dialog, DialogPanel, Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/react'
import { useUserContext } from '../components/auth/userContext';

const products = [
  { name: '研習資訊', href: '/info' },
  { name: '線上報修', href: '/repair' },
  // { name: '活動競賽', href: '/contest' },
  { name: '教育部 MOEMDM', href: 'https://mdm.edu.tw/', target: '_blank' },
  { name: '軟體採購', href: '/procurement' },
  { name: '計畫專區', href: '/plan' },
  { name: '下載專區', href: '/download' },
];

const units = [
  { name: '緣起與背景', href: '/origin' },
  { name: '數位學習推動辦公室', href: '/digital' },
  { name: '雙語學習推動辦公室', href: '/bilingual' },
  { name: '數位恆星學校', href: '/star' },
  { name: '校長科技領導學校', href: '/schoolmaster' },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { userInfo } = useUserContext();
  console.log('userInfo', userInfo);
  //處理登入
  const handleLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const url = "/api/auth/login_ischool?linkSignIn=khedu&restore_url=/main";
    window.location.href = url;
  };

  //處理登出
  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const url = "/api/auth/logout?restore_url=/";
    window.location.href = url;
  }

  return (
    <>
      <div className={`hidden max-w-[1500px] mx-auto pr-4 pt-2 -mb-2 z-10 relative ${(userInfo) ? 'xl:block' : ' lg:block'}`}>
        <a href="https://affairs.kh.edu.tw/6856/page/view/11" target="_blank" rel="noopener noreferrer"
          className='rounded-3xl bg-[#796baf] text-white text-sm cursor-pointer hover:opacity-80 px-4 py-1 table ml-auto'>舊網站</a>
      </div>
      <div className={`content flex justify-between items-center gap-4 text-Headline mx-auto p-4 ${(userInfo) ? 'xl:pt-0' : ' lg:pt-0'}`}>
        <a href="/" className='shrink-0'>
          <img src={logo} alt="" className="w-52 sm:w-auto" />
        </a>

        <a href="/aicontest" className={`hidden border-2 border-[#6cd5cc] rounded-xl text-[#6cd5cc] text-lg font-medium py-2 px-4 text-nowrap hover:shadow-[0_0_8px_#6cd5cc] mr-4 ${(userInfo) ? 'xl:block' : 'lg:block xl:mr-16'} `}>
          <div className=''>高雄市AI素養爭霸賽</div>
        </a>

        <div className='lg:w-full shrink-0 lg:shrink'>
          <header className="bg-white">
            <nav className="text-gray-900" aria-label="Global">
              <div className={`flex ${(userInfo) ? 'xl:hidden' : 'lg:hidden'} `}>
                <button
                  type="button"
                  className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 ml-auto"
                  onClick={() => setMobileMenuOpen(true)}
                >
                  <span className="sr-only">Open main menu</span>
                  <img src={menuIcon} alt="" />
                </button>
              </div>
              {/* <PopoverGroup className={`hidden lg:text-lg lg:flex justify-between items-center ml-auto ${(userInfo) ? 'max-w-4xl' : 'max-w-3xl'} `}> */}
              <PopoverGroup className={`hidden justify-between items-center lg:text-lg ml-auto ${(userInfo) ? 'xl:flex gap-x-4' : ' lg:flex gap-x-0'} `}>
                {/* <NavLink to="/unit">
                  <div className="p-2 nav hover:opacity-75 text-nowrap">
                    單位介紹
                  </div>
                </NavLink> */}

                <Popover className="relative">
                  <PopoverButton className="flex items-center gap-x-1 outline-none border-b-2 border-white hover:border-gray-200 p-2 hover:opacity-75 text-nowrap">
                    單位介紹
                    <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                  </PopoverButton>

                  <PopoverPanel
                    transition
                    className="absolute -left-14 top-full z-10 mt-3 w-56 bg-white text-center rounded-lg transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
                    style={{ boxShadow: '#cacaca 1px 1px 5px 0px' }}
                  >
                    <div className="py-5">
                      {units.map((item) => (
                        <div
                          key={item.name}
                          className="px-3 py-2 leading-6"
                        >
                          <div className="">
                            {/*<a href={item.href} className={`${location.pathname === '/' + item.href && 'active'}`}>*/}
                            <a href={item.href}>
                              <div className='nav p-2'>{item.name}</div>
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </PopoverPanel>
                </Popover>
                <Popover className="relative">
                  <PopoverButton className="flex items-center gap-x-1 outline-none border-b-2 border-white hover:border-gray-200 p-2 hover:opacity-75 text-nowrap">
                    服務項目
                    <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                  </PopoverButton>

                  <PopoverPanel
                    transition
                    className="absolute -left-8 top-full z-10 mt-3 w-44 bg-white text-center rounded-lg transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
                    style={{ boxShadow: '#cacaca 1px 1px 5px 0px' }}
                  >
                    <div className="py-5">
                      {products.map((item) => (
                        <div
                          key={item.name}
                          className="px-3 py-2 leading-6"
                        >
                          <div className="">
                            {/*<a href={item.href} className={`${location.pathname === '/' + item.href && 'active'}`}>*/}
                            <a href={item.href} target={item.target}>
                              <div className='nav p-2'>{item.name}</div>
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </PopoverPanel>
                </Popover>
                {
                  (userInfo) ?
                    <>
                      <NavLink to="/main" end>
                        <div className="p-2 nav hover:opacity-75 text-nowrap">
                          教學資源
                        </div>
                      </NavLink>
                    </> :
                    <>
                      <NavLink to="/resource" end>
                        <div className="p-2 nav hover:opacity-75 text-nowrap">
                          教學資源
                        </div>
                      </NavLink>
                    </>

                }
                <NavLink to="/lecturer">
                  <div className="p-2 nav hover:opacity-75 text-nowrap">
                    人才資源
                  </div>
                </NavLink>
                {
                  userInfo &&
                  <NavLink to="/calendar">
                    <div className="p-2 nav hover:opacity-75 text-nowrap">
                      行事曆
                    </div>
                  </NavLink>
                }
                <NavLink to="/activity">
                  <div className="p-2 nav hover:opacity-75 text-nowrap">
                    活動花絮
                  </div>
                </NavLink>
                {
                  userInfo && userInfo.isAdmin &&

                  <Popover className="relative">
                    <PopoverButton className="flex items-center gap-x-1 outline-none border-b-2 border-white hover:border-gray-200 p-2 hover:opacity-75 text-nowrap">
                      後台管理
                      <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                    </PopoverButton>

                    <PopoverPanel
                      transition
                      className="absolute top-full z-10 mt-3 bg-white text-center rounded-lg"
                      style={{ boxShadow: '#cacaca 1px 1px 5px 0px' }}
                    >
                      <div className="py-5">
                        <div className="py-3 px-2">
                          <a href="/main/announce" className="">
                            <div className='nav p-2'>公告管理</div>
                          </a>
                          <a href="/api/auth/logout?restore_url=/">
                            <div className="nav p-2 hover:opacity-75 text-nowrap">
                              <span className="text-main">{userInfo.fullName}</span>登出
                            </div>
                          </a>
                          {/* <a href="/main/software" className="px-3">
                          <div className='nav break-keep'>各校授權軟體</div>
                        </a> */}
                        </div>
                      </div>
                    </PopoverPanel>
                  </Popover>

                }
                {
                  (userInfo && !userInfo.isAdmin) ?
                    <div className="p-2 nav text-nowrap relative group cursor-pointer">
                      <div className="flex items-center gap-x-1 outline-none border-b-2 border-white hover:border-gray-200 p-2 hover:opacity-75 text-nowrap">
                        {userInfo.fullName}
                        <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                      </div>
                      <div className="absolute right-0 top-full z-10 pt-3 hidden group-hover:block w-32">
                        <div className="bg-white text-center rounded-lg" style={{ boxShadow: '#cacaca 1px 1px 5px 0px' }}>
                          <div className="py-5">
                            <div className="py-3 px-2">
                              <a href="/api/auth/logout?restore_url=/">
                                <div className="nav p-2 hover:opacity-75 text-nowrap">
                                  登出
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    :
                    (!userInfo) ?
                      <a href="/api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main">
                        <div className="p-2 nav hover:opacity-75">
                          登入
                        </div>
                      </a> : null
                }

              </PopoverGroup>
            </nav>
            <Dialog className={` ${(userInfo) ? 'xl:hidden' : 'lg:hidden'} `} open={mobileMenuOpen} onClose={setMobileMenuOpen}>
              <DialogPanel className="fixed right-0 top-0 z-10 overflow-y-auto w-auto mt-5">
                <div className="text-right">
                  <button
                    type="button"
                    className="px-4 text-gray-700 bg-white"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <img src={closeIcon} alt="" className='ml-auto' />
                  </button>
                </div>
                <div className="mt-3 sm:mt-4 flow-root">
                  <div className="divide-y divide-gray-500/10 rounded-lg bg-white" style={{ boxShadow: 'inset 0px 0px 5px 0px #d1d1d1' }}>
                    <div className="p-4 text-base leading-7 text-gray-900 max-h-[85vh] overflow-y-auto">
                      {/* <a href="unit" className="block hover:opacity-75 px-10 py-2">
                        單位介紹
                      </a> */}
                      <a href="/aicontest" className="block text-center border-2 border-[#6cd5cc] rounded-xl text-[#6cd5cc] text-nowrap hover:shadow-[0_0_8px_#6cd5cc] font-medium py-2 px-3 my-4 mx-auto">
                        高雄市AI素養爭霸賽
                      </a>
                      <hr />

                      <Popover className="relative">
                        <PopoverButton className="flex items-center gap-x-1 hover:opacity-75 px-10 py-2">
                          單位介紹
                          <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                        </PopoverButton>

                        <PopoverPanel
                          transition
                          className="static z-20 bg-gray-50"
                        >
                          <hr />
                          <div className="py-5">
                            {units.map((item) => (
                              <div
                                key={item.name}
                                className="px-4 py-2 text-base leading-4 hover:opacity-75"
                              >
                                <div className="">
                                  {/*<a href={item.href} className={`${location.pathname === '/' + item.href && 'active'}`}>*/}
                                  <a href={item.href}>
                                    <div className='p-2'>{item.name}</div>
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                          <hr />
                        </PopoverPanel>
                      </Popover>


                      {/* {[...products].map((item) => (
                        <a key={item.name} href={item.href} className="block hover:opacity-75 px-10 py-2">
                          {item.name}
                        </a>
                      ))} */}

                      <Popover className="relative">
                        <PopoverButton className="flex items-center gap-x-1 hover:opacity-75 px-10 py-2">
                          服務項目
                          <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                        </PopoverButton>

                        <PopoverPanel
                          transition
                          className="static z-20 bg-gray-50"
                        >
                          <hr />
                          <div className="py-5">
                            {products.map((item) => (
                              <div
                                key={item.name}
                                className="text-base leading-4 hover:opacity-75 px-6 py-2"
                              >
                                <div className="">
                                  {/*<a href={item.href} className={`${location.pathname === '/' + item.href && 'active'}`}>*/}
                                  <a href={item.href} target={item.target}>
                                    <div className='p-2'>{item.name}</div>
                                  </a>
                                </div>
                              </div>
                            ))}
                          </div>
                          <hr />
                        </PopoverPanel>
                      </Popover>



                      {
                        (userInfo) ?
                          <>
                            <a href="/main" className="block hover:opacity-75 px-10 py-2">
                              教學資源
                            </a>
                          </> :
                          <>
                            <a href="/resource" className="block hover:opacity-75 px-10 py-2">
                              教學資源
                            </a>
                          </>
                      }
                      <a href="lecturer" className="block hover:opacity-75 px-10 py-2">人才資源</a>
                      {
                        userInfo &&
                        <a href="calendar" className="block hover:opacity-75 px-10 py-2">行事曆</a>
                      }
                      <a href="activity" className="block hover:opacity-75 px-10 py-2">活動花絮</a>
                      <div className="block hover:opacity-75 px-8 pt-2 pb-4">
                        <a href="https://dlo.kh.edu.tw/" target="_blank" rel="noopener noreferrer"
                          className='flex justify-center rounded-3xl bg-[#796baf] text-white text-sm cursor-pointer hover:opacity-80 w-full px-6 py-1'>
                          舊網站
                        </a>
                      </div>
                      {
                        userInfo && userInfo.isAdmin &&
                        <>
                          <hr />
                          <a href='/main/announce' className='block hover:opacity-75 px-10 py-2'>公告管理</a>
                          {/* <a href='/main/software' className='block hover:opacity-75 px-10 py-2'>
                            各校授權軟體
                          </a> */}
                        </>
                      }
                      <hr />
                      {
                        (userInfo) ?
                          <a href="/api/auth/logout?restore_url=/" className='block text-base leading-7 hover:opacity-75 px-10 py-2'>
                            <span className="text-main mr-3">{userInfo.fullName}</span>
                            <span className="text-gray-900">登出</span>
                          </a>
                          :
                          <a href="/api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main">
                            <div className="block hover:opacity-75 px-10 py-2">
                              登入
                            </div>
                          </a>
                      }
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </Dialog>
          </header>

          {/* <header className="bg-white">
            <div className="text-base md:text-xl whitespace-nowrap pe-4">
              <PopoverGroup className="flex items-center gap-4 md:gap-x-12">
                <div className="text-[#5BB6AF] py-2 hover:!opacity-80">
                  李知恩
                </div>

                <Popover className="relative">
                  <PopoverButton className="flex items-center gap-x-1 leading-6 outline-none border-b-2 border-white py-2 hover:opacity-80">
                    後台管理
                    <img src={downIcon} alt="" className="h-5 w-5 flex-none" aria-hidden="true" />
                  </PopoverButton>

                  <PopoverPanel
                    transition
                    className="absolute -left-4 top-full z-10 mt-3 bg-white"
                  >
                    <div className="md:py-5">
                      <div key='1' className="px-3 md:py-2 leading-6" >
                        <a href='/main/announce'>
                          <div className='p-2'>公告管理</div>
                        </a>
                      </div>
                      <div key='2' className="px-3 md:py-2 leading-6" >
                        <a href='/'>
                          <div className='p-2'>登出</div>
                        </a>
                      </div>

                    </div>
                  </PopoverPanel>
                </Popover>
              </PopoverGroup>
            </div>
          </header> */}
        </div>
      </div>

    </>
  )

}